import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { Container } from '../../shared/models/container.model';
import { File } from '../../shared/models/file.model';
import { ViewerFrameComponent } from './viewer-frame.component';
import { ViewerParameters, ViewerTextConfig } from './viewer-frame.model';

export interface DialogResult {
  dirty: boolean // the app has written data to the site
}

@Component({
  selector: 'viewer-frame-dialog',
  template: `
    <fw-icon-button tabindex="-1" icon="close" color="slate" (click)="close()"></fw-icon-button>
    <h1 mat-dialog-title *ngIf="title">{{ title }}</h1>
    <div mat-dialog-content>
      <viewer-frame
        [applicationUrl]="applicationUrl"
        [container]="container"
        [file]="file"
        [text]="text"
        [textSaved]="textSaved"
        [saveText]="saveText"
        [params]="params"
        (close)="close()"
        (updateWidth)="setWidth($event)">
      </viewer-frame>
    </div>
  `,
  styles: [`
    :host {
      display: block;
      margin: 0;
      position: relative;
    }
    fw-icon-button {
      position: absolute;
      right: 16px;
      top: 16px;
    }
    [mat-dialog-content] {
      margin: 0;
      max-height: calc(100vh - 70px);
      padding: 0;
      border-radius: 8px;
    }
    [mat-dialog-title] {
      display: inline-block;
      margin: 5px;
    }
  `],
})
export class ViewerFrameDialog implements OnInit {
  static defaultWidth = '98vw'

  applicationUrl = this.data.applicationUrl
  container = this.data.container
  file = this.data.file
  text = this.data.text
  saveText = this.data.saveText
  textSaved = this.data.textSaved
  params = this.data.params
  title = this.data.title
  specifiedWidth = this.data.width

  @ViewChild(ViewerFrameComponent) viewerFrame: ViewerFrameComponent

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: {
      applicationUrl: string,
      container?: Container
      file?: File,
      text?: ViewerTextConfig,
      saveText?: (text: string) => Observable<void>,
      textSaved?: Observable<void>,
      params?: ViewerParameters,
      title?: string,
      width?: string,
    },
    private ref: MatDialogRef<ViewerFrameDialog, DialogResult>,
  ) { }

  ngOnInit(): void {
    this.specifiedWidth ? this.ref.updateSize(this.specifiedWidth) : this.ref.updateSize(ViewerFrameDialog.defaultWidth);
  }

  close(): void {
    this.ref.close({ dirty: Boolean(this.viewerFrame?.dirty) });
  }

  setWidth(width: number | string): void {
    const effectiveWidth = this.specifiedWidth ??
      (typeof width === 'number'
        ? `${width}px`
        : (width ?? ViewerFrameDialog.defaultWidth));

    this.ref.updateSize(effectiveWidth);
  }
}
